import { render, staticRenderFns } from "./detailFoodClaim.vue?vue&type=template&id=37e85abd&scoped=true&"
import script from "./detailFoodClaim.vue?vue&type=script&lang=js&"
export * from "./detailFoodClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailFoodClaim.vue?vue&type=style&index=0&id=37e85abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e85abd",
  null
  
)

export default component.exports